module.exports = __webpack_public_path__ + "media/team_photos/Matti-Biskup-photo-012164e6.webp";